var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_629_2057)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_629_2057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.10649 16.1749L3.10649 13.2334L23.2772 13.2334L14.2424 4.19855L16.3435 2.09743L28.9502 14.7041L16.3435 27.3108L14.2424 25.2097L23.2772 16.1749L3.10649 16.1749Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_2057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.4156,
    height: 29.4156,
    fill: "white",
    transform: "translate(30) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_629_2057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 20.8,
    fill: "white",
    transform: "translate(15.293) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.79077541bca901a32476c9b79b4048f0.svg";
export { ForwardRef as ReactComponent };